// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__Osw-O","load3":"Loader_load3__OKL7E","loader":"Loader_loader__pvYRd","loaderContainer":"Loader_loaderContainer__Budva"};